<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Sweep
                        <span v-if="is_loading || fetching_data"
                              class="button is-white has-text-right preloader"
                              :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>

            <div class="columns">
              <div class="column is-8-mobile is-8-desktop is-8-widescreen is-paddingless is-marginless">
                    <!-- TODO: HIDE SEARCH UNTIL QUERY OPTIMIZED -->
                    <!-- <search v-on:search="search($event)" :add-margin-left="searchMarginLeft"
                            class="is-12-desktop column is-paddingless is-marginless is-hidden-mobile"></search> -->
                </div>

                <div class="column is-4-mobile is-4-desktop is-4-widescreen buttons">
                    <button @click="removeFromSweep()" type="button" class="button is-button-grey is-button-small">REMOVE FROM LIST</button>
                    <span @click="deleteReview" class="button is-button-grey-outline is-button-large">DELETE</span>
                </div>

            </div>

            <!--<div class="columns is-marginless" v-if="!fetching_data">
                <div class="column is-paddingless">
                    <div class="has-text-left">
                        <h6 class="has-text-weight-bold">{{ total_records + ' results' }}</h6>
                    </div>
                </div>
            </div>-->
            <p v-if="!fetching_data" v-resultsCount="[total_records, all_records]"></p>

            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                    <tr>
                        <td class="is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey paddingless-td">
                          <label class="label is-size-7 has-text-centered clickable-checkbox">
                            <input type="checkbox" @change="checkAllRows()" v-model="allChecked">
                          </label>
                        </td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Date Published</td>
                        <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Business</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Title</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Reviewer email</td>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="8">
                                <p class="has-text-centered is-padded-20">No results found</p>
                            </td>
                        </tr>
                        <tr class="margin-bottom-20" v-for="(item, index) in items"  v-if="items.length > 0"
                            @click="gotoSweepReviewDetails(item)"
                        >
                            <td class="is-size-7-mobile is-size-7-touch paddingless-td">
                                <label class="label is-size-7 has-text-centered clickable-checkbox" @click="preventClick($event)">
                                    <input type="checkbox"
                                           v-model="checked_items"
                                           :value="item.id">
                                </label>
                            </td>
                            <td class="is-narrow-mobile is-desktop break-all">{{item.created_at | prettyDate}} <br/> {{item.created_at | prettyTime}}</td>
                            <td class="is-narrow-mobile is-desktop break-all">{{ asText(item.bizName, 80) }}</td>
                            <td class="is-narrow-mobile is-desktop break-all">{{ asText(item.review_title, 100) }}</td>
                            <td class="is-narrow-mobile is-desktop break-all">{{item.email}}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="level">
                <paginator :dataSet="dataSet" @changed="getSweepReviewsListings"></paginator>
            </div>
        </div>
        <!-- review delete modal -->
        <div class="modal is-active" v-if="deleteReviewStatus">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head headnewcl">
                    <strong>Delete review</strong>
                </header>
                <section class="modal-card-body">
                    <div class="notify-check-section">
                        <label class="label is-size-7">
                            <input
                                    type="checkbox"
                                    name="notifyReviewer"
                                    v-model="notifyReviewer"
                                    ref="notifyReviewer"
                                    @change="getCheckDisableStatus('reviewer')"
                            />
                            &nbsp; Notify reviewer
                        </label>
                    </div>
                    <div>
                        <textarea ref="revReason" :disabled="getRevDisStatus" :class="{ 'is-danger': notifyReviewer && reasonRevRequiredMessage && !deleteReviewerReason }" maxlength="350" rows="6" class="delete-reason " v-model="deleteReviewerReason"></textarea>
                        <p class="help is-danger" v-if="notifyReviewer && reasonRevRequiredMessage && !deleteReviewerReason">{{reasonRevRequiredMessage}}</p>
                    </div>

                    <div class="notify-check-section">
                        <label class="label is-size-7">
                            <input
                                    type="checkbox"
                                    name="notifyBusiness"
                                    v-model="notifyBusiness"
                                    ref="notifyBusiness"
                                    @change="getCheckDisableStatus('business')"
                            />
                            &nbsp; Notify business
                        </label>
                    </div>
                    <div>
                        <textarea ref="bizReason" :disabled="getBizDisStatus" :class="{'is-danger': notifyBusiness && reasonBizRequiredMessage && !deleteBizReason }" maxlength="350" rows="6" class="delete-reason " v-model="deleteBizReason"></textarea>
                        <p class="help is-danger" v-if="notifyBusiness && reasonBizRequiredMessage && !deleteBizReason">{{reasonBizRequiredMessage}}</p>
                    </div>

                    <div class="notify-check-section">
                        <label class="label is-size-7">
                            <input
                                    type="checkbox"
                                    name="notifyCheck"
                                    v-model="notifyCheck"
                                    ref="notifyCheck"
                                    @change="getCheckDisableStatus('none')"
                            />
                            &nbsp; Delete review without notifying anyone
                        </label>
                    </div>
                    <!-- Content ... -->
                </section>

                <footer class="modal-card-foot delete-review-footer">

                    <button class="button" @click="deleteReviewStatus=false">CANCEL</button>
                    <button class="button" @click="deleteReviewDetails" :disabled="getDisabledStatus">DELETE</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import qs from 'qs'
  import moment from 'moment'
  import Search from '../../components/Search.vue'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Reported Reviews'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Sweep Reviews'
      })
      localStorage.setItem('sweep', true)
    },
    components: {Paginator, Search},
    mixins: [misc],
    data () {
      return {
        searchMarginLeft: false,
        no_of_items: 0,
        is_loading: true,
        fetching_data: false,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        checked_items: [],
        allChecked: false,
        deleteReason: '',
        deleteReviewStatus: false,
        notifyCheck: false,
        notifyReviewer: false,
        notifyBusiness: false,
        deleteReviewerReason: '',
        deleteBizReason: '',
        reasonRevRequiredMessage: '',
        reasonBizRequiredMessage: '',
        all_records: -1
      }
    },
    created () {
      if (this.$route.query.keyword) {
          this.keyword_search = qs.stringify({keyword: this.$route.query.keyword})
          this.keyword_string = this.$route.query.keyword
      }
      this.getSweepReviewsListings(null)
    },
    methods: {
      // call when any checkbox get clicked
      getCheckDisableStatus (type) {
        switch (type) {
          case 'reviewer':
            this.notifyCheck = false
            if (this.notifyReviewer) {
              this.$refs.notifyCheck.disabled = true
              this.$refs.revReason.disabled = false
              this.$refs.revReason.focus()
            } else if (!this.notifyBusiness) {
              this.$refs.notifyCheck.disabled = false
            }
            break
          case 'business':
            this.notifyCheck = false
            if (this.notifyBusiness) {
              this.$refs.notifyCheck.disabled = true
              this.$refs.bizReason.disabled = false
              this.$refs.bizReason.focus()
            } else if (!this.notifyReviewer) {
              this.$refs.notifyCheck.disabled = false
            }
            break
          case 'none':
            this.notifyReviewer = false
            this.notifyBusiness = false
            if (this.notifyCheck) {
              this.$refs.notifyReviewer.disabled = true
              this.$refs.notifyBusiness.disabled = true
            } else {
              this.$refs.notifyReviewer.disabled = false
              this.$refs.notifyBusiness.disabled = false
            }
            break
          default:
            this.notifyReviewer = false
            this.notifyBusiness = false
            this.notifyCheck = false
        }
      },
      preventClick (event) {
        event.stopPropagation()
      },
      /**
       * Goes to reported reviews page for choosen busines
       * @param {object} item Review slug
       * @returns {void}
       */
      gotoSweepReviewDetails (item) {
        let searchedStrings = {
           keyword: this.keyword_string,
           page: this.page
        }
        let searchKeyword = qs.stringify(searchedStrings)
        this.$router.push(`/business/${item.bizSlug}/review/${item.permalink}/${item.id}?${searchKeyword}`)
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getSweepReviewsListings(1)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getSweepReviewsListings (page) {
        this.page = page || 1
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
            .then((response) => {
              this.refresh(response)
              response.data.data = undefined
              this.is_loading = false
              this.fetching_data = false
              this.allChecked = false
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }
        return `/sweep-reviews/?page=${page}`
      },
      checkAllRows () {
        this.checked_items = []
        if (this.allChecked) {
          for (let i = 0; i < this.items.length; i++) {
            this.checked_items.push(this.items[i].id)
          }
        }
      },
      removeFromSweep () {
        if (this.checked_items.length > 0) {
          axios.post('/sweep-reviews/remove', this.checked_items)
            .then(() => {
              let query = location.search.match(/page=(\d+)/)
              let page = query ? query[1] : 1
              if (page === 1) {
                window.location.reload(true)
              } else {
                this.getSweepReviewsListings(1)
              }
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
            })
        } else {
          flash('Please select one or more review(s)', 'is-warning')
        }
      },
      // delete review from sweep
      deleteReviewDetails () {
        if (this.notifyBusiness && !this.deleteBizReason) {
          this.reasonBizRequiredMessage = `Please enter a reason`
        } else if (this.notifyReviewer && !this.deleteReviewerReason) {
          this.reasonRevRequiredMessage = `Please enter a reason`
        } else {
          let params = {
            notifyStatus: this.notifyCheck,
            notifyReviewer: this.notifyReviewer,
            notifyBusiness: this.notifyBusiness,
            deleteBizReason: this.deleteBizReason,
            deleteReviewerReason: this.deleteReviewerReason,
            reviewIds: this.checked_items
          }
          axios.post('/sweep-reviews/delete', params)
              .then((response) => {
                this.recacheHomepage()
                const reviewData = []
                for (let item of this.items) {
                  if (this.checked_items.includes(item.id)) {
                    reviewData.push({bizSlug: item.bizSlug, permalink: item.permalink})
                  }
                }
                this.recacheReviewDetail(reviewData)

                this.checked_items = []
                this.getSweepReviewsListings(this.page)
                this.deleteReviewStatus = false
                this.deleteReason = ''
                this.notifyCheck = false
                flash(`Sweep review has been successfully deleted.`, 'is-success')
              })
              .catch(() => {
                flash('You are not authorized to view this resource.', 'is-danger')
              })
        }
      },
      // show delete reason modal
      deleteReview () {
        if (this.checked_items.length > 0) {
          this.deleteReviewStatus = true
        } else {
          flash('Please select one or more review(s)', 'is-warning')
        }
      }
    },
    filters: {
      prettyDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      prettyTime (date) {
        return moment(date).format('HH:mm')
      }
    },
    computed: {
      getDisabledStatus () {
        if (this.notifyCheck || this.notifyReviewer || this.notifyBusiness) {
          return false
        } else {
          return true
        }
      },
      getRevDisStatus () {
        return !this.notifyReviewer
      },
      getBizDisStatus () {
        return !this.notifyBusiness
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    tr {
        cursor: pointer;
    }
    .delete-reason{
        width: 100% !important;
        resize: none;
        padding: 5px;
    }
    .modal-card-foot > button{
        float: right;
    }

    .headnewcl{
        flex-direction:column;
    }
    .headnewcl p{
        text-align:left;    display: block;
        width: 100%;
    }
    .btninline{
        display:flex;justify-content:space-between;
    }
    .delete-review button{
        margin-top:10px;
        padding: 4px;
        border-radius: 5px;
    }
    .notify-check-section{
        margin-top: 5px;
    }
    .delete-review-footer{
        display: flex;
        justify-content: flex-end;
    }
    .modal-card-head {
        border-top: 5px solid #30AAE1;
        padding-top: 40px;
        border-bottom: none !important;
        background-color: #fff;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
    .modal-card-foot {
        border-top: none !important;
        background-color: #fff;
        border-radius: none !important;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .notify-check-section {
        margin-top: 13px;
        margin-bottom: 10px;
    }
    textarea {
        font-size: .85em !important;
    }
    textarea.is-danger {
        border-color: #ff3860;
    }
    .break-all {
        word-break: break-all;
    }
    .paddingless-td {
        padding: 0px !important;
    }
    .clickable-checkbox {
        padding: 15px !important;
        cursor: pointer;
        -webkit-user-select: none; /* webkit (safari, chrome) browsers */
        -moz-user-select: none; /* mozilla browsers */
        -khtml-user-select: none; /* webkit (konqueror) browsers */
        -ms-user-select: none; /* IE10+ */
    }
</style>



// WEBPACK FOOTER //
// src/pages/sweep/SweepReviewsListing.vue